import { useQueries } from 'react-query';
import { useTokenizedApi } from '../useTokenizedApi';
import { useActivityOverview } from './useActivityOverview';

export function useActivityCount({ profileId, overviewFilter, filters } = {}) {
  const tokenizedApi = useTokenizedApi();
  const activityOverview =
    useActivityOverview({ profileId, overviewFilter }) || [];

  const activities = useQueries(
    activityOverview.map(({ activityId, lockboxId, dateModified }) =>
      tokenizedApi.activity.activityEventQuery({
        profileId,
        lockboxId,
        activityId,
        dateModified,
      }),
    ),
  );

  return tokenizedApi.activity.filterActivity(
    activities.map(({ data }) => data),
    filters,
  ).length;
}
